var objectsJson
var singlePages
var articles
var clickableAds
var widgets
var sections
var pages
var newsRoomName
var publicationName
var zoneName
var issueName
var interstitialsFrequency
var interstitials
var accessEntitlements
var shouldIncludeAds
var isFullPageViewMode
var addZoomAds
var addZoomTables
var stylesheetRef

function createPages (isSinglePages) {
  pages = []
  for (var i = 0; i < singlePages.length; i++) {
    var page = { firstPage: null, secondPage: null }
    if (isSinglePages) {
      page.firstPage = singlePages[i]
    } else {
      let widePage = (parseInt(singlePages[i].attributes.ObjectWidth) / parseInt(singlePages[i].attributes.ObjectHeight)) > 0.8
      // if widePage is true then it means that width is getting close to being bigger than height (> 1.0). So the page will be presented too wide to be double.
      if (singlePages[i].isNgSectionFrontPage || singlePages[i].isSpread || singlePages[i].isInterstitial || widePage) {
        page.firstPage = singlePages[i]
      } else {
        page.firstPage = singlePages[i]
        if (isFullPageViewMode) {
          if (singlePages[i + 1] && !singlePages[i + 1].isNgSectionFrontPage && !singlePages[i + 1].isSpread && !singlePages[i + 1].isInterstitial) {
            singlePages[i + 1].isLastOfTwoPageView = true
            page.secondPage = singlePages[i + 1]
            i++
          }
        }
      }
    }
    pages.push(page)
  }
}

function parseJson () {
  singlePages = []
  articles = []
  clickableAds = []
  widgets = []
  sections = []
  var uniqueSections = []
  var section = { id: null, name: null, articles: [], pages: [] }
  var pageNumberCounter = 1
  var pageHasNoArticles = true
  var curNgSectionName = null
  var currentSectionModelWidth = null
  var divideSectionsWithSinglePages = objectsJson.attributes.DivideSectionsWithSinglePages !== undefined && objectsJson.attributes.DivideSectionsWithSinglePages === '1'

  if (objectsJson.attributes.NewsRoom !== '') {
    newsRoomName = objectsJson.attributes.NewsRoom
  }

  if (objectsJson.attributes.DigitalPublicationName !== undefined && objectsJson.attributes.DigitalPublicationName !== '') {
    publicationName = objectsJson.attributes.DigitalPublicationName
  } else {
    publicationName = objectsJson.attributes.ProductNameCont
  }

  if (objectsJson.attributes.ZoneCont !== '') {
    zoneName = objectsJson.attributes.ZoneCont
  }

  if (objectsJson.attributes.DigitalIssueName !== undefined && objectsJson.attributes.DigitalIssueName !== '') {
    issueName = objectsJson.attributes.DigitalIssueName
  } else {
    issueName = objectsJson.attributes.PubDateCont
  }

  if (objectsJson.attributes.InterstitialsFrequency !== undefined && objectsJson.attributes.InterstitialsFrequency !== '') {
    interstitialsFrequency = parseInt(objectsJson.attributes.InterstitialsFrequency)
  }

  for (var k = 0; k < objectsJson.content.length; k++) {
    if (objectsJson.content[k].kind === 'Stylesheet') {
      stylesheetRef = objectsJson.content[k].reference
    }
  }

  for (var i = 0; i < objectsJson.children.length; i++) {
    let pageObject = objectsJson.children[i]
    if (!isEntitledToPage(pageObject)) {
      continue
    }

    pageHasNoArticles = true
    var isStaticInterstitial = pageObject.attributes.IsInterstitial === '1' && pageObject.attributes.InterstitialAfterPageNo !== undefined && pageObject.attributes.InterstitialAfterPageNo !== ''

    var singlePage = {
      id: pageObject.id,
      attributes: {
        ObjectXPos: pageObject.attributes.ObjectXPos,
        ObjectYPos: pageObject.attributes.ObjectYPos,
        ObjectWidth: pageObject.attributes.ObjectWidth,
        ObjectHeight: pageObject.attributes.ObjectHeight,
        Page: pageObject.attributes.Page,
        Name: pageObject.attributes.Name,
        SectionName: pageObject.attributes.SectionName,
        LayoutDeskCont: pageObject.attributes.LayoutDeskCont,
        InterstitialAfterPageNo: pageObject.attributes.InterstitialAfterPageNo,
        IsInterstitial: pageObject.attributes.IsInterstitial,
        InterstitialObjectWidthPortrait: pageObject.attributes.InterstitialObjectWidthPortrait,
        InterstitialObjectHeightPortrait: pageObject.attributes.InterstitialObjectHeightPortrait,
        InterstitialObjectWidthLandscape: pageObject.attributes.InterstitialObjectWidthLandscape,
        InterstitialObjectHeightLandscape: pageObject.attributes.InterstitialObjectHeightLandscape,
        SectionModelPageWidth: '',
        LastRev: pageObject.attributes.LastRev
      },
      sections: [],
      articles: [],
      clickableAds: [],
      widgets: [],
      zoomObjects: [],
      pageNumber: null,
      isSpread: pageObject.attributes.SpreadPageName !== '',
      pdf: null,
      thumbnail: null,
      background: null,
      isNgSectionFrontPage: false,
      isLastOfTwoPageView: false,
      interstitialInfo: null,
      isInterstitial: false
    }

    if (pageObject.attributes.IsInterstitial === '1' && pageObject.attributes.InterstitialAfterPageNo === undefined) {
      singlePage.isInterstitial = true
    }

    let ngSectionName = pageObject.attributes.SectionName
    if (ngSectionName.indexOf('/') >= 0) {
      ngSectionName = ngSectionName.split('/')[0]
    }
    if (ngSectionName !== curNgSectionName) {
      if (divideSectionsWithSinglePages || curNgSectionName === null) {
        singlePage.isNgSectionFrontPage = true
      }

      if (currentSectionModelWidth !== pageObject.attributes.ObjectWidth) {
        currentSectionModelWidth = pageObject.attributes.ObjectWidth
      }
    }
    curNgSectionName = ngSectionName

    singlePage.attributes.SectionModelPageWidth = currentSectionModelWidth

    if (pageObject.attributes.SpreadPageName !== '') {
      let firstNumber = pageNumberCounter
      pageNumberCounter++
      let secondNumber = pageNumberCounter
      singlePage.pageNumber = firstNumber.toString() + '-' + secondNumber.toString()
    } else {
      singlePage.pageNumber = pageNumberCounter.toString()
    }

    pageNumberCounter++

    var content = pageObject.content
    for (let j = 0; j < content.length; ++j) {
      if (content[j].format === 'application/pdf' && content[j].type === 'Background') {
        singlePage.pdf = content[j].reference
        break
      }
    }

    for (let j = 0; j < content.length; ++j) {
      if (content[j].type === 'Background' && (content[j].format === 'image/png' || content[j].format === 'image/jpeg')) {
        singlePage.background = content[j].reference
        break
      }
    }

    for (let j = 0; j < content.length; ++j) {
      if (content[j].kind === 'Thumbnail' && (content[j].format === 'image/png' || content[j].format === 'image/jpeg')) {
        singlePage.thumbnail = content[j].reference
        break
      }
    }

    addInterstitialInfo(pageObject, singlePage)

    var layoutDesk = pageObject.attributes.LayoutDeskCont
    if (layoutDesk.indexOf('/') >= 0) {
      layoutDesk = layoutDesk.split('/')[0]
    }

    if (uniqueSections.includes(layoutDesk)) {
      layoutDesk = uniqueSections[uniqueSections.length - 1]
    }
    if (layoutDesk !== section.name && layoutDesk !== '') {
      section = { id: null, name: null, pages: [], articles: [] }
      section.name = layoutDesk
      section.id = layoutDesk + '-' + pageObject.attributes.Uid
      sections.push(section)
      if (!uniqueSections.includes(layoutDesk)) {
        uniqueSections.push(layoutDesk)
      }
    }

    if (layoutDesk === section.name && layoutDesk !== '') {
      // section.articles.push(article)

      if (singlePage.sections.indexOf(section) === -1) {
        singlePage.sections.push(section)
      }

      if (section.pages.indexOf(singlePage) === -1) {
        section.pages.push(singlePage)
      }
    }

    var children = pageObject.children
    for (var j = 0; j < children.length; j++) {
      if (children[j].kind === 'Article') {
        if (children[j].attributes.InArticleIndex === '0' && children[j].attributes.JumpOriginArticleId === undefined && children[j].attributes.CopyJumpResourcesFrom === undefined) {
          continue
        }

        if (children[j].attributes.TableInArticle === '1' && addZoomTables) {
          addZoomObjectToPage(children[j], singlePage)
          continue
        }

        pageHasNoArticles = false
        let article = addArticle(children[j], singlePage)

        if (layoutDesk === section.name && layoutDesk !== '') {
          section.articles.push(article)
        }
      } else if (children[j].kind === 'ClickableAd') {
        addClickableAd(children[j], singlePage)
      } else if (children[j].kind === 'Ad' && addZoomAds) {
        addZoomObjectToPage(children[j], singlePage)
      } else {
        addWidget(children[j], singlePage)
      }
    }
    // A section for a page with no articles should be added to sections
    if (pageHasNoArticles && !isStaticInterstitial) {
      var layoutDesk1 = pageObject.attributes.LayoutDeskCont
      if (layoutDesk1.indexOf('/') !== -1) {
        layoutDesk1 = layoutDesk1.split('/')[0]
      }
      if (uniqueSections.includes(layoutDesk1)) {
        layoutDesk1 = uniqueSections[uniqueSections.length - 1]
      }

      if (layoutDesk1 !== section.name && layoutDesk1 !== '') {
        section = { id: null, name: null, articles: [], pages: [] }
        section.name = layoutDesk1
        section.id = section.name + '-' + pageObject.attributes.Uid

        if (section.pages.indexOf(singlePage) === -1) {
          section.pages.push(singlePage)
        }
        sections.push(section)
        if (!uniqueSections.includes(layoutDesk1)) {
          uniqueSections.push(layoutDesk1)
        }
      }

      if (layoutDesk1 === section.name && layoutDesk1 !== '') {
        if (singlePage.sections.indexOf(section) === -1) {
          singlePage.sections.push(section)
        }
        if (section.pages.indexOf(singlePage) === -1) {
          section.pages.push(singlePage)
        }
      }
    }

    if (isStaticInterstitial) {
      var afterPageNo = singlePage.attributes.InterstitialAfterPageNo
      var prevPage = singlePages[getPageIndexForPageNumber(afterPageNo)]
      if (prevPage !== undefined) {
        var prevPageSections = prevPage.sections
        var lastSection = prevPageSections[prevPage.sections.length - 1]
        lastSection.pages.push(singlePage)
        prevPageSections[prevPage.sections.length - 1] = lastSection
        singlePage.sections = prevPageSections
        var indexOfSection = sections.indexOf(prevPageSections)
        if (indexOfSection !== -1) {
          sections[indexOfSection] = lastSection
        }
      }
    }

    singlePages.push(singlePage)
    if (singlePage.isNgSectionFrontPage && shouldIncludeAds) {
      var dummyPage = createCopyOfPageAndMakeItAStaticInterstitial(singlePage, pageNumberCounter, pageObject)
      singlePages.push(dummyPage)
    }
  }

  if (sections.length === 0) {
    section.id = 'dummysection'
    section.articles = articles
    section.pages = singlePages
    sections.push(section)
  }
}

function addArticle (element, page) {
  var article = {
    id: element.id,
    attributes: {
      ObjectXPos: element.attributes.ObjectXPos,
      ObjectYPos: element.attributes.ObjectYPos,
      ObjectWidth: element.attributes.ObjectWidth,
      ObjectHeight: element.attributes.ObjectHeight,
      JumpOriginArticleId: element.attributes.JumpOriginArticleId,
      JumpOriginPageId: element.attributes.JumpOriginPageId,
      TeaserText: element.attributes.TeaserText,
      Headline: element.attributes.Headline,
      JumpToArticleId: element.attributes.JumpToArticleId,
      JumpToPage: element.attributes.JumpToPage,
      IsEntryJump: element.attributes.IsEntryJump,
      JumpTo: element.attributes.JumpTo,
      Byline: element.attributes.Byline,
      Name: element.attributes.Name,
      OnlineURL: element.attributes.OnlineURL,
      LastRev: element.attributes.LastRev
    },
    contextualImage: {
      uid: '',
      reference: '',
      LastRev: ''
    },
    html: '',
    page: null,
    jumpOriginArticle: null,
    children: []
  }

  var articleContent = element.content
  for (var n = 0; n < articleContent.length; n++) {
    if (articleContent[n].format.indexOf('image') !== -1) {
      article.contextualImage.uid = articleContent[n].uid
      article.contextualImage.reference = articleContent[n].reference
    } else if (articleContent[n].kind === 'Text') {
      article.html = articleContent[n].reference
    } else if (articleContent[n].format.indexOf('application/pdf') !== -1 && checkForConvertedPdf(element, articleContent[n].reference) !== undefined) {
      article.contextualImage.uid = articleContent[n].uid
      article.contextualImage.reference = checkForConvertedPdf(element, articleContent[n].reference)
    }
  }

  for (var k = 0; k < element.children.length; k++) {
    var artChild = element.children[k]
    if (artChild.kind === 'Photo' || artChild.kind === 'Graphics') {
      var noDisplay = 'false'
      var noExport = artChild.attributes.NoExport
      var noArchive = artChild.attributes.NoArchive
      if (noExport === 'true' || noArchive === 'true') {
        noDisplay = 'true'
      }

      if (artChild.attributes.Uid === article.contextualImage.uid) {
        article.contextualImage.LastRev = artChild.attributes.LastRev
      }

      var photoObject = {
        kind: artChild.kind,
        NoDisplay: noDisplay,
        Uid: artChild.attributes.Uid,
        ObjectWidth: artChild.attributes.ObjectWidth,
        ObjectHeight: artChild.attributes.ObjectHeight,
        LastRev: artChild.attributes.LastRev,
        ImageReference: '',
        CaptionReference: ''
      }

      for (var i = 0; i < artChild.content.length; i++) {
        if (artChild.content[i].format === 'image/jpeg' || artChild.content[i].format === 'image/png') {
          photoObject.ImageReference = artChild.content[i].reference
        } else if (artChild.content[i].format === 'text/html') {
          photoObject.CaptionReference = artChild.content[i].reference
        } else if (artChild.content[i].format === 'application/pdf' && checkForConvertedPdf(element, artChild.content[i].reference) !== undefined) {
          photoObject.ImageReference = checkForConvertedPdf(element, artChild.content[i].reference)
        }
      }
      article.children.push(photoObject)
    } else {
      addWidget(artChild, page)
    }
  }

  if (article.attributes.JumpOriginArticleId !== undefined) {
    addJumpOriginArticle(article)
  }

  articles.push(article)
  page.articles.push(article)
  return article
}

function checkForConvertedPdf(articleObj, pdfRef) {
  let pdfFilename = pdfRef.split('.')[0]
  for (let key in articleObj.resources) {
    if (key.indexOf(pdfFilename) !== -1 && key !== pdfRef) {
      return key
    }
  }
}

function addJumpOriginArticle (article) {
  let originArticleId = article.attributes.JumpOriginArticleId
  let originPageId = article.attributes.JumpOriginPageId
  if (singlePages !== undefined) {
    if (originPageId !== undefined) {
      for (var i = 0; i < singlePages.length; i++) {
        let page = singlePages[i]
        if (page.id === originPageId) {
          for (var j = 0; j < page.articles.length; j++) {
            if (page.articles[j].id === originArticleId) {
              article.jumpOriginArticle = page.articles[j]
              return
            }
          }
        }
      }
    } else {
      // Support for issues without JumpOriginPageId.
      for (var k = 0; k < singlePages.length; k++) {
        let page = singlePages[k]
        for (var l = 0; l < page.articles.length; l++) {
          if (page.articles[l].id === originArticleId) {
            article.jumpOriginArticle = page.articles[l]
            return
          }
        }
      }
    }
  }
}

function addWidget (element, page) {
  if (element.kind === 'PhotoGallery' || element.kind === 'Widget' || element.kind === 'Video') {
    var widget = {
      id: null,
      kind: element.kind,
      attributes: {
        ObjectXPos: element.attributes.ObjectXPos,
        ObjectYPos: element.attributes.ObjectYPos,
        ObjectWidth: element.attributes.ObjectWidth,
        ObjectHeight: element.attributes.ObjectHeight,
        OEmbedHtml: element.attributes.OEmbedHtml,
        LastRev: element.attributes.LastRev
      },
      page: null
    }

    widget.id = element.id
    if (widget.id.indexOf('#') !== -1) {
      widget.id = widget.id.replace('#', 'I')
    }

    widgets.push(widget)
    page.widgets.push(widget)
  }
}

function addClickableAd (element, page) {
  var ad = {
    id: element.id,
    attributes: {
      ObjectXPos: element.attributes.ObjectXPos,
      ObjectYPos: element.attributes.ObjectYPos,
      ObjectWidth: element.attributes.ObjectWidth,
      ObjectHeight: element.attributes.ObjectHeight,
      InterstitialObjectWidthPortrait: element.attributes.InterstitialObjectWidthPortrait,
      InterstitialObjectHeightPortrait: element.attributes.InterstitialObjectHeightPortrait,
      Link: element.attributes.Link,
      LastRev: element.attributes.LastRev
    },
    page: null
  }

  clickableAds.push(ad)
  page.clickableAds.push(ad)
}

function addZoomObjectToPage (element, page) {
  var obj = {
    id: element.id,
    attributes: {
      ObjectXPos: element.attributes.ObjectXPos,
      ObjectYPos: element.attributes.ObjectYPos,
      ObjectWidth: element.attributes.ObjectWidth,
      ObjectHeight: element.attributes.ObjectHeight
    },
    page: null
  }
  page.zoomObjects.push(obj)
}

function addPagesToArticles () {
  for (var i = 0; i < singlePages.length; i++) {
    for (var j = 0; j < articles.length; j++) {
      if (singlePages[i].articles.indexOf(articles[j]) >= 0) {
        articles[j].page = singlePages[i]
      }
    }
  }
}

function addPagesToClickableAds () {
  for (var i = 0; i < singlePages.length; i++) {
    for (var j = 0; j < clickableAds.length; j++) {
      if (singlePages[i].clickableAds.indexOf(clickableAds[j]) >= 0) {
        clickableAds[j].page = singlePages[i]
      }
    }
  }
}

function addPagesToWidgets () {
  for (var i = 0; i < singlePages.length; i++) {
    for (var j = 0; j < widgets.length; j++) {
      if (singlePages[i].widgets.indexOf(widgets[j]) >= 0) {
        widgets[j].page = singlePages[i]
      }
    }
  }
}

function addPagesToZoomObjects () {
  for (var i = 0; i < singlePages.length; i++) {
    for (var j = 0; j < singlePages[i].zoomObjects.length; j++) {
      singlePages[i].zoomObjects[j].page = singlePages[i]
    }
  }
}

function insertStaticInterstitials () {
  var staticInters = []
  for (var i = 0; i < singlePages.length; i++) {
    var page = singlePages[i]
    if ((page.attributes.IsInterstitial === '1' && page.attributes.InterstitialAfterPageNo !== undefined && page.attributes.InterstitialAfterPageNo !== '') || page.interstitialAdAfterPage !== undefined) {
      staticInters.push(page)
    }
  }
  for (var j = 0; j < staticInters.length; j++) {
    var inter = staticInters[j]
    var afterPageNo = inter.attributes.InterstitialAfterPageNo
    if (inter.interstitialAdAfterPage !== undefined) {
      afterPageNo = inter.interstitialAdAfterPage
    }
    var prevPageIndex = getPageIndexForPageNumber(afterPageNo)
    if (prevPageIndex === undefined) {
      return
    }

    inter.sections = singlePages[prevPageIndex].sections
    inter.pageNumber = '-' + j

    var indexOfInter = singlePages.indexOf(inter)
    if (indexOfInter !== -1) {
      singlePages.splice(indexOfInter, 1)
    }
    singlePages.splice(prevPageIndex + 1, 0, inter)
  }
}

function getPageIndexForPageNumber (pageNumber) {
  for (var i = 0; i < singlePages.length; i++) {
    if (singlePages[i].pageNumber.indexOf('-') !== -1) {
      var spreadPageNum = singlePages[i].pageNumber.split('-')[1]
      if (spreadPageNum === pageNumber) {
        return i
      }
    }
    if (singlePages[i].pageNumber === pageNumber) {
      return i
    }
  }
}

function addInterstitialInfo (pageJson, page) {
  if ((pageJson.attributes.InterstitialAfterPageNo !== undefined && pageJson.attributes.InterstitialAfterPageNo !== '') || page.interstitialAdAfterPage !== undefined) {
    var interstitialInfo = {
      interstitialAfterPageNo: null,
      portraitRef: null,
      landscapeRef: null,
      portraitPdf: null,
      landscapePdf: null,
      portaitClickableAds: [],
      landscapeClickableAds: []
    }

    interstitialInfo.interstitialAfterPageNo = pageJson.attributes.InterstitialAfterPageNo

    if (page.interstitialAdAfterPage !== undefined) {
      interstitialInfo.interstitialAfterPageNo = page.interstitialAdAfterPage
    }

    var content = pageJson.content
    for (let j = 0; j < content.length; ++j) {
      if (content[j].format === 'application/pdf' && content[j].type === 'Background') {
        if (content[j].orientation === 'Portrait') {
          interstitialInfo.portraitPdf = content[j].reference
        } else if (content[j].orientation === 'Landscape') {
          interstitialInfo.landscapePdf = content[j].reference
        }
      }
      if (content[j].format === 'image/png' && content[j].type === 'Background') {
        if (content[j].orientation === 'Portrait') {
          interstitialInfo.portraitRef = content[j].reference
        } else if (content[j].orientation === 'Landscape') {
          interstitialInfo.landscapeRef = content[j].reference
        }
      }
    }

    for (var i = 0; i < pageJson.children.length; i++) {
      var child = pageJson.children[i]
      if (child.kind === 'ClickableAd') {
        var ad = { id: null, json: null, page: page }
        ad.id = child.id
        ad.json = child
        if (child.attributes.Orientation === 'Portrait') {
          interstitialInfo.portaitClickableAds.push(ad)
        } else if (child.attributes.Orientation === 'Landscape') {
          interstitialInfo.landscapeClickableAds.push(ad)
        }
      }
    }
    page.interstitialInfo = interstitialInfo
  }
}

function createInterstitials () {
  var simpleInterstitials = []
  for (var i = 0; i < pages.length; i++) {
    var page = pages[i]
    if (page.firstPage.attributes.IsInterstitial === '1' && page.firstPage.attributes.InterstitialAfterPageNo === undefined) {
      simpleInterstitials.push(page)
    }
  }
  if (simpleInterstitials.length > 0) {
    interstitials = []
  }
  for (var j = 0; j < simpleInterstitials.length; j++) {
    var pageIndex = pages.indexOf(simpleInterstitials[j])
    if (pageIndex !== -1) {
      pages.splice(pageIndex, 1)
    }
  }

  var interstitialPageNumber = 10000
  for (var k = 0; k < simpleInterstitials.length; k++) {
    interstitialPageNumber++
    var leftInterstitial = simpleInterstitials[k]
    leftInterstitial.firstPage.pageNumber = interstitialPageNumber.toString()

    var interstitialSet = { leftInterstitial: leftInterstitial, rightInterstitial: null, section: leftInterstitial.firstPage.sections[0] }
    interstitialPageNumber++

    var rightInterstitial = { firstPage: null, secondPage: null }
    var firstPage = {
      id: leftInterstitial.firstPage.id + '2',
      attributes: leftInterstitial.firstPage.attributes,
      sections: leftInterstitial.firstPage.sections,
      articles: leftInterstitial.firstPage.articles,
      clickableAds: leftInterstitial.firstPage.clickableAds,
      widgets: leftInterstitial.firstPage.widgets,
      pageNumber: interstitialPageNumber.toString(),
      isSpread: leftInterstitial.firstPage.isSpread,
      pdf: leftInterstitial.firstPage.pdf,
      thumbnail: leftInterstitial.firstPage.thumbnail,
      background: leftInterstitial.firstPage.background,
      isNgSectionFrontPage: leftInterstitial.firstPage.isNgSectionFrontPage,
      isLastOfTwoPageView: leftInterstitial.firstPage.isLastOfTwoPageView,
      interstitialInfo: leftInterstitial.firstPage.interstitialInfo,
      isInterstitial: leftInterstitial.firstPage.isInterstitial
    }

    rightInterstitial.firstPage = firstPage
    interstitialSet.rightInterstitial = rightInterstitial
    interstitials.push(interstitialSet)
  }

  // Test
  // var strippedPage = pages[pages.length - 1]
  // strippedPage.firstPage.sections = []
  // strippedPage.firstPage.pageNumber = '10001'
  // strippedPage.firstPage.isInterstitial = true
  // interstitials.push(strippedPage)
  //
  // var strippedPage2 = { firstPage: null, secondPage: null }
  //
  // var singlePage = {
  //   id: 'something_else',
  //   json: strippedPage.firstPage.json,
  //   sections: [],
  //   articles: [],
  //   clickableAds: strippedPage.firstPage.clickableAds,
  //   widgets: [],
  //   pageNumber: '10002',
  //   isSpread: false,
  //   pdf: strippedPage.firstPage.pdf,
  //   isNgSectionFrontPage: strippedPage.firstPage.isNgSectionFrontPage,
  //   isLastOfTwoPageView: strippedPage.firstPage.isLastOfTwoPageView,
  //   interstitialInfo: strippedPage.firstPage.interstitialInfo,
  //   isInterstitial: true
  // }
  // strippedPage2.firstPage = singlePage
  //
  // interstitials.push(strippedPage2)
  // pages.pop()
}

function createCopyOfPageAndMakeItAStaticInterstitial (singlePage, pageNumberCounter, pageJson) {
  // Create a dummy page with no content.
  // This page will act as a template page for inserting google ads as interstitial.
  // The page will follow the same behaviour as a static interstitial page.
  var dummyPage = {
    id: singlePage.id + 'dummy',
    attributes: singlePage.attributes,
    sections: singlePage.sections,
    articles: [],
    clickableAds: [],
    widgets: [],
    pageNumber: null,
    isSpread: false,
    pdf: null,
    thumbnail: null,
    background: null,
    isNgSectionFrontPage: true,
    isLastOfTwoPageView: false,
    interstitialInfo: null,
    isInterstitial: false,
    interstitialAdAfterPage: (pageNumberCounter - 1).toString()
  }

  addInterstitialInfo(pageJson, dummyPage)
  return dummyPage
}

function isEntitledToPage (page) {
  if (accessEntitlements.includes('eedition') || accessEntitlements.length === 0) {
    // full access to issue.
    return true
  }
  // map section name...
  // var entitlementlayoutDesk = ''
  // if (page.attributes.SectionName === 'B') {
  //   entitlementlayoutDesk = 'Sports'
  // }

  if (accessEntitlements.includes(page.attributes.SectionName)) {
    return true
  }
  return false
}

function CciDataSource (json, isSinglePages, entitlements, includeAds, fullPageViewMode, enableZoomToAds, enableZoomToTables) {
  objectsJson = json
  accessEntitlements = entitlements
  shouldIncludeAds = includeAds
  isFullPageViewMode = fullPageViewMode
  addZoomAds = enableZoomToAds
  addZoomTables = enableZoomToTables

  parseJson()
  insertStaticInterstitials()
  addPagesToArticles()
  addPagesToClickableAds()
  addPagesToWidgets()
  addPagesToZoomObjects()
  createPages(isSinglePages)
  createInterstitials()
}

function CciDataSourceUpdatePages (newSinglePages, isSinglePages, fullPageViewMode) {
  singlePages = newSinglePages
  isFullPageViewMode = fullPageViewMode
  createPages(isSinglePages)
}

function CciDataSourceClearMemory () {
  // Clear all variables.
  objectsJson = null
  singlePages = null
  articles = null
  clickableAds = null
  widgets = null
  sections = null
  pages = null
  newsRoomName = null
  publicationName = null
  zoneName = null
  issueName = null
  interstitialsFrequency = null
  interstitials = null
  accessEntitlements = null
  shouldIncludeAds = null
  isFullPageViewMode = null
  addZoomAds = null
  addZoomTables = null
}

export { CciDataSource, CciDataSourceUpdatePages, CciDataSourceClearMemory, sections, articles, clickableAds, widgets, pages, singlePages, issueName, publicationName, newsRoomName, zoneName, interstitialsFrequency, interstitials, stylesheetRef }
